import { Upload } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { InfoNote, Panel } from '@/components/common/Panel'
import { uploadTemplateDraft } from '../api'
import { applyUploadedFile } from '../lib/templateHelpers'
import { revokePreviewUrl } from '../lib/previewUrl'
import type { SablonSurum } from '../types'
import { FileUploadZone } from './FileUploadZone'
import { MethodCards } from './MethodCards'
import { TemplateEditorWorkspace } from './TemplateEditorWorkspace'
import { VariableMappingPanel } from './VariableMappingPanel'

export function TemplateSourceStep({ surum, onChange }: { surum: SablonSurum; onChange: (next: SablonSurum) => void }) {
  const { t } = useTranslation()

  return (
    <div className="space-y-4">
      <MethodCards
        value={surum.method}
        onChange={(method) => {
          if (method === 'sistem') {
            revokePreviewUrl(surum.uploadedFile)
            onChange({ ...surum, method, uploadedFile: undefined, demoVariables: undefined, variableMappings: [] })
          } else {
            onChange({ ...surum, method })
          }
        }}
      />
      {surum.method === 'sistem' ? (
        <TemplateEditorWorkspace surum={surum} onChange={onChange} />
      ) : (
        <div className="grid grid-cols-[minmax(0,1fr)] gap-4 lg:grid-cols-[minmax(0,1fr)_300px]">
          <div className="space-y-4">
            <Panel
              icon={Upload}
              title={t('hr.belgeler.upload.title')}
              hint={surum.method === 'docx' ? t('hr.belgeler.upload.docxCapabilities') : t('hr.belgeler.upload.pdfCapabilities')}
            >
              <FileUploadZone
                value={surum.uploadedFile}
                accept={surum.method === 'pdf' ? 'pdf' : 'docx'}
                onChange={(file, raw) => {
                  onChange(applyUploadedFile(surum, file))
                  if (raw && surum.sablonId && surum.sablonId !== 'draft') void uploadTemplateDraft(surum.sablonId, raw).catch(() => undefined)
                }}
                onClear={() => {
                  revokePreviewUrl(surum.uploadedFile)
                  onChange({ ...surum, uploadedFile: undefined, demoVariables: undefined, variableMappings: [] })
                }}
              />
            </Panel>
            {surum.method === 'docx' ? (
              <VariableMappingPanel surum={surum} onChange={(variableMappings) => onChange({ ...surum, variableMappings })} />
            ) : null}
          </div>
          <InfoNote title={t('hr.belgeler.upload.limitsTitle')} className="h-fit">
            <ul className="list-disc space-y-1 pl-4">
              <li>{t('hr.belgeler.upload.limitNoParse')}</li>
              <li>{t('hr.belgeler.upload.limitDemo')}</li>
              <li>{t('hr.belgeler.upload.limitPdf')}</li>
            </ul>
          </InfoNote>
        </div>
      )}
    </div>
  )
}
